import {BTN_ACTIONS, textSystem} from "../../utils/Constant";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import moment from "moment/moment";
import {ICorrectiveSubsectionColumnsProps} from "../models/CorrectiveSubsectionModels";

const CorrectionColumns = (props: ICorrectiveSubsectionColumnsProps) => {
  const {handleOpenCorrectionModal} = props;
  return [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: "50px",
      },
      cellStyle: {
        width: "50px",
        textAlign: "center",
        ...textSystem,
      },
      render: (_row: any, _index: number, stt: number) => <span>{stt}</span>,
    },
    {
      name: "Thao tác",
      field: "",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any) => (
        <div className="d-flex justify-content-center gap-3">
          <CustomIconButton
            variant="view"
            onClick={() => handleOpenCorrectionModal(row, BTN_ACTIONS.VIEW)}
          >
            <i className="bi bi-eye-fill text-gray-700"></i>
          </CustomIconButton>
          <CustomIconButton
            variant="edit"
            onClick={() => handleOpenCorrectionModal(row, BTN_ACTIONS.EDIT)}
          >
            <i className="bi bi-pencil-square text-primary"></i>
          </CustomIconButton>
        </div>
      ),
    },
    {
      name: "Đợt đánh giá",
      field: "planName",
      headerStyle: {
        width: "160px",
        minWidth: "160px",
      },
      cellStyle: {
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Điểm báo cáo",
      field: "reportScore",
      cellStyle: {
        minWidth: "200px",
        ...textSystem,
      },
    },
    {
      name: "Ngày tạo",
      field: "createdDate",
      cellStyle: {
        minWidth: "150px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any) => (
        <div>
          {row?.createdDate
            ? moment(row?.createdDate).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
  ];
};

export default CorrectionColumns;